import React from 'react';

interface Props {
  status: any;
}

export default class BulkUpsertActionAccountTypes extends React.Component<Props> {
  getStatusClass = (bulkAction: any): string =>
    bulkAction.isSuccess() ? 'green' : bulkAction.isFail() ? 'red' : 'gray';

  render() {
    const { status } = this.props;
    return (
      <table className="organization__table">
        <thead>
          <tr>
            <th className="organization__th">勘定科目名</th>
            <th className="organization__th">処理結果</th>
          </tr>
        </thead>
        <tbody>
          {status.actionExpensesAccountTypes.map((expenses_account_type: any, i: number) => (
            <tr key={i} className="organization__tr">
              <td className="organization__td">{expenses_account_type.code}</td>
              <td className={`organization__td ${this.getStatusClass(expenses_account_type)}`}>
                {expenses_account_type.statusMessage()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}
